<template>


    <v-layout row>
      <v-flex xs10 offset-xs1>
        <v-card>
          <v-toolbar color="blue darken-3" dark>
           
  
            <v-toolbar-title>Gemessene MYOIDs nach Auswerter</v-toolbar-title>

               

          </v-toolbar>
    <v-card-text>

          <apexchart   width="70%" type="bar" :options="LVoptions_byusers" :series="LVseries"></apexchart>

  
          <apexchart   width="70%"  type="bar" :options="LVoptions_remaining" :series="LVseries_remaining"></apexchart>  
 

         
         
    </v-card-text>  

      
   


     <v-card-text>

        <apexchart  width="70%" type="bar" :options="LAoptions_byusers" :series="LAseries"></apexchart>
    </v-card-text>  

        <v-card-text>

        <apexchart width="70%" type="bar" :options="LAoptions_remaining" :series="LAseries_remaining"></apexchart>  
        </v-card-text>



     <v-card-text>

        <apexchart  width="70%" type="bar" :options="Docoptions_byusers" :series="Docseries"></apexchart>
     </v-card-text>  

        <v-card-text>

        <apexchart  width="70%" type="bar" :options="Docoptions_remaining" :series="Docseries_remaining"></apexchart>  
        </v-card-text>

      <v-card-text>
        <apexchart  width="70%" type="bar" :options="LoadTriesOptions" :series="LoadTriesSeries"></apexchart>  
      </v-card-text>


      </v-card>
      </v-flex>
    </v-layout>
</template>

<script>


import { authenticationService } from '@/services';
import { myoidService } from '@/services';

import { store } from '@/store';
import { mapMutations } from "vuex";




export default {
    data () {
        return {
            user: authenticationService.currentUserValue,
            LVoptions_remaining: {},
            LVoptions_byusers: {},
            LAoptions_remaining: {},
            LAoptions_byusers: {},
            LVChartData: [],
            LAChartData: [],
            DocChartData: [],
            LoadTriesData: [],
  
            LVoptions: {
                title: {
                  text: undefined,
                  align: 'center',
                  margin: 10,
                  //offsetX: 0,
                  //offsetY: 0,
                  floating: true,
                  style: {
                    fontSize:  '16px',
                    color:  '#263238'
                  },
                },
                
                chart: {
                  toolbar: {
                      show: true,
                      tools: {
                        download: true,
                        selection: true,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: true,
                        reset: true,
                      },
                    autoSelected: 'zoom' 
                  },
                  
                },
                  xaxis: {
                     text: "(n)",
                     categories: [],

                   /* title: {
                    text: "Monat/Jahr",
                    offsetX: 0,
                    offsetY: 0,
                    style: {
                        color: undefined,
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        cssClass: 'apexcharts-xaxis-title',
                    },
                  },*/
                },
                legend: {
                    position: 'right',
                  //  offsetY: -40
                },

                plotOptions: {
                  bar: {
                    dataLabels: {
                      position: 'top', // top, center, bottom
                    },
                  }   
                },
                  dataLabels: {
                  enabled: true,
                  formatter: function (val) {
                    return val;
                  },
                  offsetY: -20,
                  style: {
                    fontSize: '12px',
                    colors: ["#304758"]
                  }
                }, 
                
            },

           LoadTriesOptions: {
                title: {
                  text: undefined,
                  align: 'center',
                  margin: 10,
                  //offsetX: 0,
                  //offsetY: 0,
                  floating: true,
                  style: {
                    fontSize:  '16px',
                    color:  '#263238'
                  },
                },
                
                chart: {
                  toolbar: {
                      show: true,
                      tools: {
                        download: true,
                        selection: true,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: true,
                        reset: true,
                      },
                    autoSelected: 'zoom' 
                  },
                  
                },
                  xaxis: {
                     text: "(n)",
                     categories: [],

                   /* title: {
                    text: "Monat/Jahr",
                    offsetX: 0,
                    offsetY: 0,
                    style: {
                        color: undefined,
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        cssClass: 'apexcharts-xaxis-title',
                    },
                  },*/
                },
                legend: {
                    position: 'right',
                  //  offsetY: -40
                },

                plotOptions: {
                  bar: {
                    dataLabels: {
                      position: 'top', // top, center, bottom
                    },
                  }   
                },
                  dataLabels: {
                  enabled: true,
                  formatter: function (val) {
                    return val;
                  },
                  offsetY: -20,
                  style: {
                    fontSize: '12px',
                    colors: ["#304758"]
                  }
                }, 
                
            },

            Docoptions: {
                title: {
                  text: undefined,
                  align: 'center',
                  margin: 10,
                  //offsetX: 0,
                  //offsetY: 0,
                  floating: true,
                  style: {
                    fontSize:  '16px',
                    color:  '#263238'
                  },
                },
                
                chart: {
                  toolbar: {
                      show: true,
                      tools: {
                        download: true,
                        selection: true,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: true,
                        reset: true,
                      },
                    autoSelected: 'zoom' 
                  },
                  
                },
                  xaxis: {
                     text: "(n)",
                     categories: [],

                   /* title: {
                    text: "Monat/Jahr",
                    offsetX: 0,
                    offsetY: 0,
                    style: {
                        color: undefined,
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        cssClass: 'apexcharts-xaxis-title',
                    },
                  },*/
                },
                legend: {
                    position: 'right',
                  //  offsetY: -40
                },

                plotOptions: {
                  bar: {
                    dataLabels: {
                      position: 'top', // top, center, bottom
                    },
                  }   
                },
                  dataLabels: {
                  enabled: true,
                  formatter: function (val) {
                    return val;
                  },
                  offsetY: -20,
                  style: {
                    fontSize: '12px',
                    colors: ["#304758"]
                  }
                }, 
                
            },

              LAoptions: {
                title: {
                  text: undefined,
                  align: 'center',
                  margin: 10,
                  //offsetX: 0,
                  //offsetY: 0,
                  floating: true,
                  style: {
                    fontSize:  '16px',
                    color:  '#263238'
                  },
                },
                chart: {
                  toolbar: {
                      show: true,
                      tools: {
                        download: true,
                        selection: true,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: true,
                        reset: true,
                      },
                    autoSelected: 'zoom' 
                  },
                },
                  xaxis: {
                     text: "(n)",
                    categories: [],

                                        
                },
                legend: {
                    position: 'right',
                    offsetY: 40
                },

                plotOptions: {
                  bar: {
                    dataLabels: {
                      position: 'top', // top, center, bottom
                    },
                  }   
                },
                  dataLabels: {
                  enabled: true,
                  formatter: function (val) {
                    return val;
                  },
                  offsetY: -20,
                  style: {
                    fontSize: '12px',
                    colors: ["#304758"]
                  }
                }, 
                
  

            },


            LAseries: [],
            LAseries_remaining:[],

            LVseries: [],
            LVseries_remaining:[],
           
            Docseries: [],
            Docseries_remaining:[],

            LoadTriesSeries: []
        };
    },

    methods: {
      ...mapMutations(["setSnackbar"]),

            
    },



     async created () {
      
        await myoidService.GetMeasuresByUserbyMonth("LV").then(d => this.LVChartData = d);   
    

        
        for(var i=0; i<this.LVChartData.series.length-1; i=i+2) {
          this.LVseries.push({name: this.LVChartData.series_name[i], data:this.LVChartData.series[i]  })
        }

        for(var i=0; i<this.LVChartData.categories.length;i++) {
                this.LVoptions.xaxis.categories[i] = this.LVChartData.categories[i];
        }
       
        for(var i=1; i<this.LVChartData.series.length-1; i=i+2) {

              this.LVseries_remaining.push({name: this.LVChartData.series_name[i], data:this.LVChartData.series[i]  })    
          
        }

        this.LVoptions_byusers  =JSON.parse(JSON.stringify(this.LVoptions));
        this.LVoptions_byusers.title.text="Messungen(LV) nach Auswerter";

        this.LVoptions_remaining  =JSON.parse(JSON.stringify(this.LVoptions));
        this.LVoptions_remaining.title.text="Verbleibende MYOIDs (LV)";



        await myoidService.GetMeasuresByUserbyMonth("LAA").then(d => this.LAChartData = d);    
        
        for(var i=0; i<this.LAChartData.series.length-1; i=i+2) {
          this.LAseries.push({name: this.LAChartData.series_name[i], data:this.LAChartData.series[i]  })
        }

        for(var i=0; i<this.LAChartData.categories.length;i++) {
                this.LAoptions.xaxis.categories[i] = this.LAChartData.categories[i];
        }
       
        for(var i=1; i<this.LAChartData.series.length-1; i=i+2) {

              this.LAseries_remaining.push({name: this.LAChartData.series_name[i], data:this.LAChartData.series[i]  })
         
        }
        this.LAoptions_byusers  =JSON.parse(JSON.stringify(this.LAoptions));
        this.LAoptions_byusers.title.text="Messungen(LA) nach Auswerter";
        this.LAoptions_remaining  =JSON.parse(JSON.stringify(this.LAoptions));
        this.LAoptions_remaining.title.text="Verbleibende MYOIDs (LA)";




        await myoidService.GetMeasuresByUserbyMonth("Qualikontrolle").then(d => this.DocChartData = d);    
        this.Docseries.push({name: this.DocChartData.series_name[this.DocChartData.series.length-3], data:this.DocChartData.series[this.DocChartData.series.length-3]  })
        for(var i=0; i<this.DocChartData.categories.length;i++) {
                this.Docoptions.xaxis.categories[i] = this.DocChartData.categories[i];
        }
        
        this.Docseries_remaining.push({name: this.DocChartData.series_name[this.DocChartData.series.length-2], data:this.DocChartData.series[this.DocChartData.series.length-2]  })      
        this.Docoptions_byusers  =JSON.parse(JSON.stringify(this.Docoptions));
        this.Docoptions_byusers.title.text="Verlauf Qualikontrolle";
        this.Docoptions_remaining  =JSON.parse(JSON.stringify(this.Docoptions));
        this.Docoptions_remaining.title.text="Verbleibende MYOIDs Qualikontrolle";



        await myoidService.GetLoadTries().then(d => this.LoadTriesData = d);    
       // this.LoadTriesSeries.push({name: this.LoadTriesData.series_name[this.LoadTriesData.series.length-3], data:this.LoadTriesData.series[this.LoadTriesData.series.length-3]  })
        for(var i=0; i<this.LoadTriesData.series.length; i++) {
          this.LoadTriesSeries.push({name: this.LoadTriesData.series_name[i], data:this.LoadTriesData.series[i]  })
        }
        for(var i=0; i<this.LoadTriesData.categories.length;i++) {
                this.LoadTriesOptions.xaxis.categories[i] = this.LoadTriesData.categories[i];
        }   
        this.LoadTriesOptions  =JSON.parse(JSON.stringify(this.LoadTriesOptions));
        this.LoadTriesOptions.title.text="Ladeversuche";



     console.log(this.LoadTriesData);
     

    },



};
</script>